import React from 'react';
import useHasMounted from '../../hooks/useHasMounted';
import InsiderTradesStaticShell from './InsiderTradesStaticShell';
import InsiderTradesContent from './InsiderTradesContent';

const InsiderTrades = ({ stock }) => {
  const hasMounted = useHasMounted();

  if (!hasMounted) {
    return <InsiderTradesStaticShell />;
  }

  return <InsiderTradesContent stock={stock} />;
};

export default InsiderTrades;
